import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';

@Component({
  standalone: false,
  selector: 'sbnb-default-payout-method-option',
  templateUrl: './default-payout-method-option.component.html',
  styleUrls: ['./default-payout-method-option.component.scss'],
})
export class DefaultPayoutMethodOptionComponent implements OnInit {
  @Input() isDefault: boolean;
  @Output() isDefaultChanged: EventEmitter<boolean> = new EventEmitter();

  origDefault: boolean;

  constructor() { }

  ngOnInit(): void {
    this.origDefault = this.isDefault;
  }

  checkedDefault(event: MatCheckboxChange) {
    this.isDefaultChanged.emit(event.checked);
  }
}
